import React, { useEffect } from 'react';

import { useGenericModal } from '@neptune/shared/common-business-logic';
import {
  FETCH_STATUS_FAILED,
  FETCH_STATUS_PENDING,
  FETCH_STATUS_SUCCESS,
} from '@neptune/shared/common-domain';
import { Layout, Link, Modal } from '@neptune/shared/venus-ui';

import { useApiToken } from 'common/hooks/useApiToken';
import {
  UserProfileLink,
  UserProfileLinkProps,
} from 'components/user-panel/user-profile-link/UserProfileLink';

import { SetupTutorial } from './SetupTutorial';
export const API_TOKEN_MODAL_NAME = 'API_TOKEN_MODAL';

export const ApiTokenModal = () => {
  const { token, status, error, refetchToken } = useApiToken();
  const { isOpen, close } = useGenericModal(API_TOKEN_MODAL_NAME);

  let apiToken: string | undefined;

  useEffect(() => {
    if (isOpen === true) {
      refetchToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  switch (status) {
    case FETCH_STATUS_FAILED: {
      apiToken = `<<< FETCHING API TOKEN FAILED (${error}) >>>`;
      break;
    }

    case FETCH_STATUS_PENDING: {
      apiToken = '<<< FETCHING API TOKEN... >>>';
      break;
    }

    case FETCH_STATUS_SUCCESS: {
      apiToken = token;
      break;
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={close} data={{ role: 'api-token-modal' }}>
      <Modal.Header title="Your API Token" onClose={close} />

      <SetupTutorial apiToken={apiToken}>
        <Layout.Column>
          <Link<UserProfileLinkProps>
            component={UserProfileLink}
            editMode
            data-role="revoke-token-link"
            onClick={close}
          >
            I want to generate a new API token
          </Link>
        </Layout.Column>
      </SetupTutorial>

      <Modal.Footer>
        <Modal.Button variant="primary" onClick={close}>
          Close
        </Modal.Button>
      </Modal.Footer>
    </Modal>
  );
};
